// extracted by mini-css-extract-plugin
export var aboveInput = "_kq-0";
export var actionButton = "_kq-5";
export var actionButtonContainer = "_kq-1";
export var actionIcon = "_kq-6";
export var aiInfoContainer = "_kq-2";
export var attachmentWrapper = "_kq-7";
export var bold = "_kq-3";
export var checkIcon = "_kq-8";
export var clickingRecipientBar = "_kq-11";
export var commentThreadSwitch = "_kq-a";
export var draftImage = "_kq-b";
export var draftImageContainer = "_kq-c";
export var draftImages = "_kq-e";
export var editButton = "_kq-g";
export var editor = "_kq-f";
export var editorContainer = "_kq-y";
export var editorErrorTooltipWrapper = "_kq-9";
export var headerDivider = "_kq-h";
export var icon = "_kq-i";
export var info = "_kq-j";
export var internal = "_kq-n";
export var internalDivider = "_kq-k";
export var internalMessage = "_kq-l";
export var messageInputCard = "_kq-m";
export var messageInputForm = "_kq-o";
export var messageInputFormInternal = "_kq-p";
export var options = "_kq-q";
export var publicMessageCustomer = "_kq-s";
export var publicMessageMerchant = "_kq-r";
export var removeImageButton = "_kq-d";
export var replyButtons = "_kq-t";
export var showSignatureButton = "_kq-u";
export var spinner = "_kq-v";
export var verticalButtonDivider = "_kq-4";
export var visibilitySelector = "_kq-w";
export var warning = "_kq-x";
export var wrappingText = "_kq-z";
export var writingInternalNoteTopBorder = "_kq-10";